
export class Items{

    itemName: string;
    itemType: string;
    itemStatus: string;
    itemImageUrl: string;
    itemChoices: ItemChoice[];

    constructor(values: Object = {}) {
        Object.assign(this, values);
    }
}

export class ItemChoice{

    itemChoiceName: string;
    itemChoiceQuantity: string;
    itemChoicePrice: string;
    itemChoiceTotalPrice: string;   
    itemMinVal: string;
    itemMaxVal: string;
    isChecked: Boolean;
    
    constructor(values: Object = {}) {
        Object.assign(this, values);
    }
}